var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "14px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.0249333333 14.96 0.0249333333 14.96 13.7133333 0 13.7133333"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My-Project",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cell-04",
    transform: "translate(-32.000000, -22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(32.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-student_male",
    transform: "translate(0.666667, 1.333333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48,0 L0,3.11666667 L2.49333333,4.15389333 L2.49333333,7.41891333 C2.13554,7.75987667 1.87,8.19808 1.87,8.72666667 C1.87,9.50084667 2.40544333,10.07556 3.08238333,10.3554367 C3.89334,12.2940033 5.51774667,13.7133333 7.48,13.7133333 C9.44225333,13.7133333 11.06666,12.2940033 11.88011,10.3554367 C12.5545567,10.07556 13.09,9.50084667 13.09,8.72666667 C13.09,8.19808 12.82446,7.75987667 12.4666667,7.41891333 L12.4666667,4.15389333 L13.7133333,3.63528 L13.7133333,6.85666667 L14.96,6.85666667 L14.96,3.11666667 L7.48,0 Z M4.36333333,6.23333333 L10.5966667,6.23333333 C10.9401233,6.23333333 11.22,6.51321 11.22,6.85666667 L11.22,8.01108 L11.5316667,8.19122333 C11.7217833,8.29781333 11.8433333,8.48543667 11.8433333,8.72666667 C11.8433333,9.04830667 11.61457,9.29639333 11.30789,9.33753333 L10.9401233,9.38864667 L10.8086,9.73210333 C10.1659433,11.4076233 8.88748667,12.4666667 7.48,12.4666667 C6.07251333,12.4666667 4.79405667,11.4076233 4.1514,9.73210333 L4.01738333,9.38864667 L3.65211,9.33753333 C3.34543,9.29639333 3.11666667,9.04830667 3.11666667,8.72666667 C3.11666667,8.48543667 3.23821667,8.29781333 3.42833333,8.19122333 L3.74,8.01108 L3.74,6.85666667 C3.74,6.51321 4.01987667,6.23333333 4.36333333,6.23333333 Z",
    id: "Fill-1",
    fill: "#0CAEFF",
    mask: "url(#mask-2)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/student.ab8a17a2.svg";
export { ForwardRef as ReactComponent };